import { ContentSeparator } from './ContentSeparator.styled'
import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'

export const ContentSeparatorRegistration = createRegisterableComponent(
    'content-separator',
    (props, _services) => <ContentSeparator {...props} />,
)
